import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Actions, createEffect } from '@ngrx/effects';
import { AbstractEffects } from '../AbstractEffects';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { switchMap } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';
import { Action } from '@ngrx/store';
import { logger } from '../../util/logger';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AzureLogEffects extends AbstractEffects {
  logAction$: Observable<{}> = createEffect(
    () =>
      this.actions$.pipe(
        switchMap(action => {
          if (action.type) {
            if (isLoggeableAction(action)) {
              this.azureMonitoringService.logEvent(action.type, { payload: this.getStringifiedActionPayload(action), type: action.type, version: environment.version });
            } else {
              this.azureMonitoringService.logEvent(action.type);
            }
          }
          return of({});
        })
      ),
    { dispatch: false }
  );

  constructor(azureMonitoringService: AzureMonitoringService, private actions$: Actions, translateService: TranslateService, notificationService: NotificationService) {
    super(translateService, azureMonitoringService, notificationService);
  }

  getStringifiedActionPayload(action: LoggeableAction): string {
    try {
      let payload = action.payload;
      if (typeof action.logPayload === 'function') {
        payload = action.logPayload();
      } else if (Array.isArray(action.logPayload)) {
        payload = {};
        action.logPayload.forEach(key => payload[key] = action.payload[key]);
      }
      let result = JSON.stringify(payload);
      if (result.length > 5000) {
        logger.warn(` logging (maybe) too long (${result.length}) for ${action.type}`);
        result = result.substring(0, 8192);
      }
      return result;
    } catch (e) {
      if (!environment.production) {
        logger.error(`stringifying payload of action ${action.type} failed.`);
        this.azureMonitoringService.logException(e, { message: `stringifying payload of action ${action.type} failed.` });
      }
      return 'Unable to stringify action object';
    }
  }
}

interface LoggeableAction extends Action {
  logPayload: boolean | string[] | (() => object);
  payload: any;
}

function isLoggeableAction(action: Action): action is LoggeableAction {
  return action['logPayload'] && action['payload'];
}
